import React, { Component } from 'react'
import { Link } from 'react-router'
import * as R from 'ramda'
import { connect } from 'react-redux'

import TextField from 'material-ui/TextField'
import {List, ListItem} from 'material-ui/List'


import { stringifyNumber } from 'utils/stuff'

let select = state => state


export class Omnibox extends Component{
	constructor(props){
		super(props)
		this.state={
			results: []
		  , preResult: {}
			, value: ''
		}
	}
	camelCaseToTitleCase = (camelCase) => {
		if (!camelCase || camelCase == "" || typeof camelCase != 'string') {
			return camelCase;
		}

		camelCase = camelCase.trim();
		var newText = "";
		for (var i = 0; i < camelCase.length; i++) {
			if (/[A-Z]/.test(camelCase[i])
				&& i != 0
				&& /[a-z]/.test(camelCase[i-1])
			) {
				newText += " ";
			}
			if (i == 0 && /[a-z]/.test(camelCase[i])){
				newText += camelCase[i].toUpperCase();
			} else {
				newText += camelCase[i];
			}
		}
		return newText;
	}
	findInObject = (criteria, object) => {
		let foundedKey = -1
		let foundBy = undefined
		let foundValue = undefined
		criteria= criteria.toLowerCase()
		R.values(object).forEach((field, indx) => {
			if(!field){
				return false
			}
			field = (field.toLowerCase)? field.toLowerCase(): field
			if(
				typeof field == 'string' && ~field.indexOf(criteria)
			){
				foundedKey = indx
				return false
			}else if(typeof field == 'object' && field.length){
				field.forEach((subField, index) => {
					if(~field.indexOf(criteria)){
						foundedKey = [indx, index]
						return false
					}else{
						return true
					}
				})
				if(!foundedKey){
					return true
				}else{
					return false
				}
			}else{
				return true
			}
		})
		if(~foundedKey){
			if(typeof foundedKey != 'object'){
				foundBy = R.keys(object)[foundedKey]
				foundValue = object[foundBy]
			}else{
				foundBy = R.keys(object)[foundedKey[0]]
				foundValue = object[foundBy][foundedKey[1]]
			}
			return ({foundBy: this.camelCaseToTitleCase(foundBy), foundValue: foundValue})
		}else {
			return undefined
		}
	}
	findData = (criteria) =>{
		let results = R.map(ent => {
			if(ent.type == 'property'){
				let tenant = (
							ent.leaseID
							&& this.props.data.db[ent.leaseID]
							&& this.props.data.db[ent.leaseID].tenantsIDs
							&& this.props.data.db[ent.leaseID].tenantsIDs[0]
							&& this.props.data.db[this.props.data.db[ent.leaseID].tenantsIDs[0]]
						)? this.props.data.db[this.props.data.db[ent.leaseID].tenantsIDs[0]]
							: undefined
				let projects = R.map(project => project.title, R.filter(entity => entity && entity.type == 'project' && entity.propertyID == ent._id, R.values(this.props.data.db)))
				let tasks = R.reduce((res,next) =>
					R.concat(res, next||[])
				  , []
				  , R.map(project =>
						project.tasks
					  , R.filter(
							entity =>
								entity && entity.type == 'project' && entity.propertyID == ent._id
						  , R.values(this.props.data.db)
						)
					)
				)
				let newPropertyObj ={
					address: ent.address
				  , alias: ent.alias
				  , tenantName: (tenant)? (tenant.firstName) ? `${tenant.firstName} ${tenant.lastName}` : tenant.tenant : ''
				  , tenantPhone: (tenant)? tenant.phoneNumber: ''
				  , project: projects
				  , task: tasks
				  , manager: (this.props.data.db[ent.managerID])?this.props.data.db[ent.managerID].name : ''
				  , insuranceCompany : ent.insuranceCompany
				  , insuranceNumber : ent.insuranceNumber
				  , insuranceAgent : ent.insuranceAgent
				  , insurancePhone : ent.insurancePhone
				  , insuranceFax : ent.insuranceFax
				  , insuranceEmail : ent.insuranceEmail
				  , insuranceWeb : ent.insuranceWeb
				  , taxesPaid : ent.taxesPaid
				  , taxesNumber : ent.taxesNumber
				  , hoaName : ent.hoaName
				  , hoaNumber : ent.hoaNumber
				  , hoaPhone : ent.hoaPhone
				  , hoaFax : ent.hoaFax
				  , hoaEmail : ent.hoaEmail
				  , hoaWeb : ent.hoaWeb
				  , agentID : ent.agentID
				  , loanNumber : ent.loanNumber
				  , loanPhone : ent.loanPhone
				  , loanBank : ent.loanBank
				}
				if(ent.utilities && ent.utilities.length){
					ent.utilities.map((el, indx)=> {
						newPropertyObj[`${stringifyNumber(indx)}UtilitiesAccount`] = el.account
						newPropertyObj[`${stringifyNumber(indx)}UtilitiesCompany`] = el.company
						newPropertyObj[`${stringifyNumber(indx)}UtilitiesPhone`] = el.phone
						newPropertyObj[`${stringifyNumber(indx)}UtilitiesEmail`] = el.email
					})
				}
				let foundBy = this.findInObject(criteria, newPropertyObj)
				if(!foundBy){
					return undefined
				}else{
					return ({doc: ent, foundBy : foundBy.foundBy + ': ' + foundBy.foundValue})
				}
			}else if(ent.type == 'tenant'){
				let newTenantObj ={
					propertyAddress: (ent.leaseID && this.props.data.db[ent.leaseID] && this.props.data.db[ent.leaseID].propertyID)? this.props.data.db[this.props.data.db[ent.leaseID].propertyID].address: ''
				  , propertyAlias:  (ent.leaseID && this.props.data.db[ent.leaseID] && this.props.data.db[ent.leaseID].propertyID)? this.props.data.db[this.props.data.db[ent.leaseID].propertyID].alias: ''
				  , tenantName: (ent.firstName) ? `${ent.firstName} ${ent.lastName}` : ent.tenant
				  , tenantPhone: ent.phoneNumber
				  , project: R.map(project => project.title, R.filter(entity => entity == 'project' && entity.tenantID == ent._id, this.props.data.db))
				}
				let foundBy = this.findInObject(criteria, newTenantObj)
				if(!foundBy){
					return undefined
				}else{
					return ({doc: ent, foundBy : foundBy.foundBy + ': ' + foundBy.foundValue})
				}
			}else if(ent.type == 'repairman'){
				let newRepairman ={
					propertyAddress: (ent.tasks)? R.map(taskID => (this.props.data.db[taskID] && this.props.data.db[this.props.data.db[taskID].projectID] && this.props.data.db[this.props.data.db[this.props.data.db[taskID].projectID].propertyID])?this.props.data.db[this.props.data.db[this.props.data.db[taskID].projectID].propertyID].address:'', ent.tasks) : ''
				  , propertyAlias:  (ent.tasks)? R.map(taskID => (this.props.data.db[taskID] && this.props.data.db[this.props.data.db[taskID].projectID] && this.props.data.db[this.props.data.db[this.props.data.db[taskID].projectID].propertyID])?this.props.data.db[this.props.data.db[this.props.data.db[taskID].projectID].propertyID].alias:'', ent.tasks) : ''
				  , name: ent.firstName
				}
				let foundBy = this.findInObject(criteria, newRepairman)
				if(!foundBy){
					return undefined
				}else{
					return ({doc: ent, foundBy : foundBy.foundBy + ': ' + foundBy.foundValue})
				}
			}else if(ent.type == 'owner'){
				let newOwner ={
					name: ent.firstName
				  , phoneNumber:  ent.phoneNumber
				  , cellNumber: ent.cellNumber
				}
				let foundBy = this.findInObject(criteria, newOwner)
				if(!foundBy){
					return undefined
				}else{
					return ({doc: ent, foundBy : foundBy.foundBy + ': ' + foundBy.foundValue})
				}
			}else{
				return undefined
			}
		}, R.values(this.props.data.db))
		return R.filter(result => result !== undefined, results)
	}
	unFocusFunc = () => {
		document.onclick = (evt) => {
			if(this.state.value.length){
				let el = evt.target
				let clear = true
				while(el.parentNode && el.parentNode !== null){
					if(el.parentNode.className == 'omnibox-holder') clear = false
					el = el.parentNode
				}
				if(clear){
					this.setState({
						  value: ""
					  , preResult: {}
						, results: []
					})
				}
			}
		}
	}
	render(){
		return(
			<div
				style={{
					...this.props.style
				  , zIndex: '3000'
				  , position: "absolute"
				}}
				className="omnibox-holder"
			>
				<TextField
					style={{
						marginTop: "0px"
					  , height: "40px"
					}}
					className="no-underline"
					inputStyle = {{
						fontWeight: "normal"
					  , paddingLeft: "28px"
					  , fontSize: "14px"
					}}
					underlineShow = {false}
					hintText="Type here to search"
					hintStyle={{
						fontWeight: "normal"
					  , fontSize: "14px"
					  , bottom: "6px"
					  , left: "28px"
					  , fontStyle: "italic"
					}}
					key={'omnibox'}
					fullWidth={true}
					value={this.state.value}
					onChange={
						(evt) =>{
							let value = evt.target.value.toLowerCase()
							this.setState({value})
							this.unFocusFunc(value)
							if(!value.length){
								this.setState({preResult: {}, results: []})
								return
							}
							let preResult = this.findData(value)
							preResult = {
								properties: R.filter(ent => ent.doc.type == 'property', preResult)
							  , tenants: R.filter(ent => ent.doc.type == 'tenant', preResult)
							  , repairmen: R.filter(ent => ent.doc.type == 'repairman', preResult)
							  , owners: R.filter(ent => ent.doc.type == 'owner', preResult)
							  , comments: R.map(
									(res) =>
										(
											{doc: res}
										)
										, R.filter(
											comment =>
												R.any(
													ent =>{
														if(typeof comment.body == 'object'
															&&
															!!~R.map(comEntry => comEntry.text, comment.body.blocks).join(' ').toLowerCase().indexOf(value)
														)
														return comment.body && (
															(typeof comment.body == 'string' && !!~comment.body.toLowerCase().indexOf(ent.doc._id))
															|| (
																typeof comment.body == 'object'
																&&
																!!~R.map(comEntry => comEntry.text, comment.body.blocks).join(' ').toLowerCase().indexOf(value)
															)
														)
													}
												  , preResult
												)
											  , R.reduce(
													(res, cur) =>
														R.concat(res, cur)
													  , []
													  , R.values(
																R.filter(
																	coms => coms
																  , R.map(
																		ent =>{
																			return(R.prop('comments', ent))?
																				R.map(
																					comment => ({
																						...comment
																					  , ...{
																							_id: ent._id
																						  , type: ent.type
																						  , isComment: true
																						}
																					})
																			  , R.prop('comments', ent))
																				:
																					undefined}
																	  , this.props.data.db)
																)
														)
												)
										)
								)
							}
							// results = R.filter(res => res !== undefined || !res, R.values(results))
							this.setState({preResult})
						}
					}
				/>
				{/*(this.props.hideOmni)?
					<svg
						width="20px"
						height="20px"
						viewBox="0 0 22 22"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							float: "right"
						  , marginTop: "6px"
						  , marginLeft: "16px"
						  , marginRight: "34px"
						  , position: "relative"
						  , bottom: "42px"
						  , left: "20px"
						  , marginBottom: "-30px"
						}}
						onTouchTap={this.props.hideOmni}
					>
						<title>Group</title>
						<desc>Created with Sketch.</desc>
						<defs></defs>
						<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
							<g id="Group" transform="translate(1.000000, 1.000000)" stroke="#FFF" strokeWidth="2">
								<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
								<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
							</g>
						</g>
					</svg>
					: <svg
							width="20px"
							height="20px"
							viewBox="0 0 22 22"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							style={{
								float: "right"
							  , marginTop: "6px"
							  , marginLeft: "16px"
							  , marginRight: "34px"
							  , position: "relative"
							  , bottom: "42px"
							  , left: "20px"
							  , marginBottom: "-30px"
							}}
						>
							<title>Group</title>
							<defs></defs>
							<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="Group" transform="translate(1.000000, 1.000000)" stroke="#FFF">
									<path d="M18.5,18.5 L12.5,12.5" id="Line" strokeWidth="3" strokeLinecap="square"></path>
									<circle id="Oval-1" strokeWidth="2" cx="7" cy="7" r="7"></circle>
								</g>
							</g>
						</svg>
				*/}
				{(R.keys(this.state.preResult).length && !this.state.results.length)?
					<div
						style={{
							overflow: "hidden"
						  , maxHeight: '600px'
						  , width: '650px'
						  , position: "absolute"
						  , marginTop: "-5px"
							, boxShadow: "1px 1px 1px #000"
							, backgroundColor: "#FFF"
						  , ...this.props.resultsStyle
						}}
						speed={0.8}
				        className="area"
				        contentClassName="content"
				        horizontal={false}
						verticalScrollbarStyle={{
							width: "20px"
						  , borderRadius: "13px"
						  , marginLeft: "3px"
						  , backgroundImage: "url(/assets/manager/img/bar.png)"
						  , backgroundSize: "100%"
						  , backgroundRepeat: "no-repeat"
						  , backgroundColor: "#f5f6f5"
						  , backgroundPosition: "center"
						}}
						minScrollSize={"50"}
						verticalContainerStyle={{
							width: "26px"
						  , backgroundColor: "#cdcdcd"
						  , opacity: "1 !important"
						}}
					>
						<List
							className="omnibox-holder"
						>
							<ListItem
								style={{
									minHeight: '73px'
								  , overflow: 'hidden'
								}}
								key={`properties`}
								primaryText={
									<p>
										Properties
										<span
											style={{
												verticalAlign: 'middle'
											  , padding: '3px'
											  , display: 'inline-block'
											  , width: '20px'
											  , textAlign: 'center'
											  , marginLeft: '11px'
											}}
										>
											{this.state.preResult.properties.length}
										</span>
									</p>
								}
								onClick={() => (this.state.preResult.properties.length)? this.setState({results: this.state.preResult.properties}): ''}
							/>
							<ListItem
								style={{
									minHeight: '73px'
								  , overflow: 'hidden'
								}}
								key={`tenants`}
								primaryText={
									<p>
										Tenants
										<span
											style={{
												verticalAlign: 'middle'
											  , padding: '3px'
											  , display: 'inline-block'
											  , width: '20px'
											  , textAlign: 'center'
											  , marginLeft: '11px'
											}}
										>
											{this.state.preResult.tenants.length}
										</span>
									</p>
								}
								onClick={() => (this.state.preResult.tenants.length)? this.setState({results: this.state.preResult.tenants}): ''}
							/>
							<ListItem
								style={{
									minHeight: '73px'
								  , overflow: 'hidden'
								}}
								key={`repairmen`}
								primaryText={
									<p>
										Repairmen
										<span
											style={{
												verticalAlign: 'middle'
											  , padding: '3px'
											  , display: 'inline-block'
											  , width: '20px'
											  , textAlign: 'center'
											  , marginLeft: '11px'
											}}
										>
											{this.state.preResult.repairmen.length}
										</span>
									</p>
								}
								onClick={() => (this.state.preResult.repairmen.length)? this.setState({results: this.state.preResult.repairmen}): ''}
							/>
							<ListItem
								style={{
									minHeight: '73px'
								  , overflow: 'hidden'
								}}
								key={`owners`}
								primaryText={
									<p>
										Owners
										<span
											style={{
												verticalAlign: 'middle'
											  , padding: '3px'
											  , display: 'inline-block'
											  , width: '20px'
											  , textAlign: 'center'
											  , marginLeft: '11px'
											}}
										>
											{this.state.preResult.owners.length}
										</span>
									</p>
								}
								onClick={() => (this.state.preResult.owners.length)? this.setState({results: this.state.preResult.owners}): ''}
							/>
							<ListItem
								style={{
									minHeight: '73px'
								  , overflow: 'hidden'
								}}
								key={`comments`}
								primaryText={
									<p>
										Comments
										<span
											style={{
												verticalAlign: 'middle'
											  , padding: '3px'
											  , display: 'inline-block'
											  , width: '20px'
											  , textAlign: 'center'
											  , marginLeft: '11px'
											}}
										>
											{this.state.preResult.comments.length}
										</span>
									</p>
								}
								onClick={() => (this.state.preResult.comments.length)? this.setState({results: this.state.preResult.comments}): ''}
							/>

							</List>
						</div>
						: ""
					}
					{(this.state.results.length)?
						<div
							style={{
								overflow: "hidden"
							  , maxHeight: '600px'
							  , width: '650px'
								, backgroundColor: "#FFF"
								, boxShadow: "1px 1px 1px #000"
							  , ...this.props.resultsStyle
							}}
							speed={0.8}
					        className="area"
					        contentClassName="content"
					        horizontal={false}
							verticalScrollbarStyle={{
								width: "20px"
							  , borderRadius: "13px"
							  , marginLeft: "3px"
							  , backgroundImage: "url(/assets/manager/img/bar.png)"
							  , backgroundSize: "100%"
							  , backgroundRepeat: "no-repeat"
							  , backgroundColor: "#f5f6f5"
							  , backgroundPosition: "center"
							}}
							minScrollSize={"50"}
							verticalContainerStyle={{
								width: "26px"
							  , backgroundColor: "#cdcdcd"
							  , opacity: "1 !important"
							}}
						>
							<List
							 	className="omnibox-holder"
							>
								<ListItem
									style={{
										minHeight: '73px'
									  , overflow: 'hidden'
									}}
									key={`Back-btn`}
									onClick={()=> this.setState({results: []})}
									primaryText={
										<p>
											Back
										</p>
									}
								/>
								{R.map(result=>
									<ListItem
										style={{
											minHeight: '73px'
										  , overflow: 'hidden'
										}}
										key={`${result.doc._id}-${(result.foundBy)?result.foundBy.replace(' ', ''):'comment'}-${Math.random()}`}
										primaryText={
											<p>
												<span
													style={{
														float: 'left'
													  , maxWidth: '50%'
													  , fontWeight: '100 !important'
													}}
												>
													<Link
														to={(result.doc.type == 'task')? `/manager/tasks/${result.doc._id}`
																	: (result.doc.type == 'property')? `/manager/properties/${result.doc._id}`
																		: (result.doc.type == 'lease')? `/manager/leases/${result.doc._id}`
																			: (result.doc.type == 'project')? `/manager/projects/${result.doc._id}`
																				: (result.doc.type == 'tenant')? `/manager/tenants/${result.doc._id}`
																					: (result.doc.type == 'repairman')? `/manager/repairmen/${result.doc._id}`
																						: (result.doc.type == 'tenant')? `/manager/tenants/${result.doc._id}`
																							: (result.doc.type == 'owner')? `/manager/owners/${result.doc._id}`
																								: ''}
														onClick={() => this.setState({value: "", preResult: {}, results: []})}
													>
														{(result.doc.isComment)?
															<p>
																	{(typeof result.doc.body == 'string')?
																		result.doc.body
																		: (typeof result.doc.body == 'object')?
																		  	R.map(lineEntry => lineEntry.text , result.doc.body.blocks).join('\s')
																			: ''
																	}
															</p>
															:(result.doc.type == 'task')?
																<span>
																	<span>
																		{`Task: ${result.doc.taskContent}`}
																	</span><br />
																	<span
																		style={{
																			fontSize: '11px'
																		}}
																	>
																		{`From project: ${
																			(this.props.data.db[result.doc.projectID])?
																				this.props.data.db[result.doc.projectID].title
																				: 'No project'
																		}`}
																	</span>
																</span>
																:(result.doc.type == 'property')?
																	`Property: ${result.doc.alias}`
																	:(result.doc.type == 'repairman')?
																		`Repairman: ${result.doc.firstName}`
																		:(result.doc.type == 'tenant')?
																			`Tenant: ${(result.doc.firstName) ? `${result.doc.firstName} ${result.doc.lastName}` : result.doc.tenant}`
																			:(result.doc.type == 'lease')?
																				`Lease`
																				:(result.doc.type == 'owner')?
																					`Owner: ${result.doc.firstName}`
																					: ''
														}
													</Link>
												</span>
												{(result.foundBy)?
													<span
														style={{
															float: 'right'
														  , fontSize: '10pt'
														  , maxWidth: '50%'
														}}
													>
														Found by {result.foundBy}
													</span>
													: ""
												}
											</p>
										}
									/>
								, R.sort((prev, next) => (prev.doc.type > next.doc.type)? -1:(prev.doc.type < next.doc.type)? 1: 0, R.values(this.state.results))
								)}
							</List>
						</div>
						: ''
					}
			</div>

		)
	}
}

export default connect(select)(Omnibox)



// WEBPACK FOOTER //
// ./src/components/Omnibox.js